import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from './core/loading/loading.component';
import { ThemeService } from './services/theme.service';
import { OnInit } from '@angular/core';
import { environment } from '../environments/environment.railgisv1';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, LoadingComponent],
    standalone: true
})
export class AppComponent implements OnInit{
  title = 'MAPFOREST';

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
   /* railgis
    eyeforest*/
    this.themeService.setTheme(environment.THEME);
  }
}
